import { useEffect } from 'react'
import { notifyUpdateAvailable } from '../utils/appUpdateState.js'

const POLL_INTERVAL_MS = 5 * 60 * 1000
const CURRENT_VERSION = import.meta.env.VITE_BUILD_ID

async function fetchLatestVersion() {
  const response = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' })
  if (!response.ok) return null
  const data = await response.json()
  return data?.version ?? null
}

export function useAppVersionCheck() {
  useEffect(() => {
    if (import.meta.env.DEV) return undefined

    let cancelled = false

    const checkVersion = async () => {
      try {
        const latestVersion = await fetchLatestVersion()
        if (cancelled || !latestVersion) return
        if (latestVersion !== CURRENT_VERSION) {
          notifyUpdateAvailable()
        }
      } catch {
        // Offline or transient network errors — do not prompt
      }
    }

    checkVersion()
    const intervalId = setInterval(checkVersion, POLL_INTERVAL_MS)

    const onVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        checkVersion()
      }
    }
    document.addEventListener('visibilitychange', onVisibilityChange)

    return () => {
      cancelled = true
      clearInterval(intervalId)
      document.removeEventListener('visibilitychange', onVisibilityChange)
    }
  }, [])
}
